<template>
	<div>
		<h3 v-if="isParent">Parent Filters</h3>
		<h3 v-else>Child Filters</h3>
		<v-container fluid class="py-0">
			<v-row no-gutters class="mb-6">
				<div style="flex-grow: 1">
					<v-text-field
						v-model="search"
						class="py-0 my-0 mb-2 mr-2"
						append-icon="mdi-magnify"
						label="Search"
						single-line
						hide-details
					/>
				</div>
				<div>
					<v-btn color="primary" @click="addFilter()">
						<v-icon> mdi-plus</v-icon>
						Add
					</v-btn>
				</div>
			</v-row>
		</v-container>
		<v-data-table
			dense
			:headers="headers"
			:search="search"
			:items="items"
			:disable-pagination="true"
			sort-by="Order"
			item-key="Id"
			fixed-header
			:loading="loading"
			loading-text="Loading..."
			hide-default-footer
		>
			<template v-slot:[`item.filter`]="{ item }">
				<v-icon>mdi-table</v-icon>
				<span
					v-if="
						item.FilterGridViewFieldId && item.FilterGridViewField
					"
					>{{ item.FilterGridViewField.Label }}</span
				>
			</template>
			<template v-slot:[`item.operator`]="{ item }">
				<span v-if="item.FilterOperator">{{ getOperator(item) }}</span>
			</template>
			<template v-slot:[`item.value`]="{ item }">
				<v-icon v-if="item.ValueGridViewField">mdi-table</v-icon>
				<span
					v-if="item.ValueGridViewFieldId && item.ValueGridViewField"
					>{{ item.ValueGridViewField.Label }}</span
				>
				<span v-else>{{ item.Value }}</span>
			</template>
			<template v-slot:[`item.actions`]="{ item }">
				<v-btn
					class="action-btn"
					fab
					small
					icon
					elevation="1"
					color="success"
					@click="editFilter(item)"
				>
					<v-icon small color="primary">mdi-pencil</v-icon>
				</v-btn>
				<v-btn
					class="action-btn"
					fab
					small
					icon
					elevation="1"
					color="success"
					@click="deleteFilter(item)"
				>
					<v-icon color="error" small>mdi-delete</v-icon>
				</v-btn>
			</template>
		</v-data-table>

		<ConnectorFilterModal
			v-if="showDialog && selectedFilter"
			:showDialog="showDialog"
			:filter="selectedFilter"
			:filterType="filterType"
			@close="onClose"
		/>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import {
	ConnectorFiltersGetters,
	ConnectorsListGetters,
} from '../../../../../store/getters';
import { ConnectorFiltersActions } from '../../../../../store/actions';
import ConfirmDialog from '@/components/core/dialogs/confirmDialog';
import ConnectorFilterModal from './ConnectorFilterModal.vue';
import { gridViewConnectorFilterType } from '../../../../../enums/gridViewConnectorFilterType';
import { advancedFilterOperators } from '../../../../../enums/dropdownHelpers/advancedFilterOperators';

export default {
	name: 'ConnectorFilters',
	props: {
		filterType: Number,
	},
	components: { ConnectorFilterModal },
	data() {
		return {
			search: '',
			loading: false,
			connectorId: 1,
			selectedFilter: null,
			showDialog: false,
			headers: [
				{
					text: 'Filter',
					value: 'filter',
					sortable: false,
				},
				{
					text: 'Operator',
					value: 'operator',
					sortable: false,
				},
				{
					text: 'Value',
					value: 'value',
					sortable: false,
				},
				{ text: '', value: 'actions', sortable: false, align: 'end' },
			],
		};
	},
	computed: {
		...mapGetters({
			selectedConnector: [ConnectorFiltersGetters.SELECTED_CONNECTOR],
			parentFilters: [ConnectorFiltersGetters.PARENT_FILTERS],
			childFilters: [ConnectorFiltersGetters.CHILD_FILTERS],
			gridViewFields: [ConnectorsListGetters.GRID_VIEW_FIELDS],
		}),
		items() {
			if (gridViewConnectorFilterType.Parent == this.filterType) {
				return this.parentFilters;
			}
			if (gridViewConnectorFilterType.Child == this.filterType) {
				return this.childFilters;
			}
			return [];
		},
		isParent() {
			if (this.filterType == gridViewConnectorFilterType.Parent)
				return true;
			return false;
		},
		filteredItems() {
			if (!this.search) return this.items;
			return this.items.filter((x) => {
				return (
					x.Label &&
					x.Label.toLowerCase().includes(this.search.toLowerCase())
				);
			});
		},
	},
	mounted() {
		this.$store.dispatch(
			ConnectorFiltersActions.LOAD,
			this.selectedConnector
		);
	},
	destroyed() {
		this.$store.dispatch(ConnectorFiltersActions.CLEAR);
	},
	methods: {
		addFilter() {
			this.selectedFilter = {};
			this.showDialog = true;
		},

		editFilter(item) {
			this.selectedFilter = item;
			this.showDialog = true;
		},
		deleteFilter(item) {
			ConfirmDialog({
				message: 'Are you sure you want to delete this connector?',
			}).then((isDelete) => {
				if (!isDelete) return;
				this.$store.dispatch(ConnectorFiltersActions.DELETE, item);
			});
		},
		onClose() {
			this.selectedFilter = {};
			this.showDialog = false;
		},

		getOperator(item) {
			if (!item) return null;
			if (!item.FilterOperator) return null;

			let operator = advancedFilterOperators.find(
				(x) => x.value == item.FilterOperator
			);
			if (!operator) return null;
			return operator.label;
		},
	},
};
</script>
